import { ThemeProvider } from "@mui/material/styles"
import { createRoot } from "react-dom/client"

import theme from "../../mui-theme"
import DailyReportPromptDialog, {
  dailyReportPromptMessage,
} from "./DailyReportPromptDialog"

export { dailyReportPromptMessage }

export function promptDailyReportSubmission(clientName) {
  if (typeof document === "undefined") {
    return Promise.resolve(false)
  }

  return new Promise((resolve) => {
    const container = document.createElement("div")
    document.body.appendChild(container)
    const root = createRoot(container)

    const finish = (openReport) => {
      root.unmount()
      container.remove()
      resolve(openReport)
    }

    root.render(
      <ThemeProvider theme={theme}>
        <DailyReportPromptDialog
          open
          clientName={clientName}
          onYes={() => finish(true)}
          onNo={() => finish(false)}
        />
      </ThemeProvider>
    )
  })
}
